import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {DataFiltersComponent} from '../../../shared/data-filters/data-filters.component';
import {Subscription} from 'rxjs';
import {BluechatSearchCriteria} from '../../shared/bluechat-search-criteria.model';

@Component({
  selector: 'app-bluechat-filters',
  templateUrl: './bluechat-filters.component.html',
  styleUrls: ['./bluechat-filters.component.scss']
})
export class BluechatFiltersComponent implements AfterViewInit {

  @ViewChild('dataFilters') public filtersComponent: DataFiltersComponent;
  @Input() public filters: BluechatSearchCriteria;
  @Output() public reset = new EventEmitter<void>();
  @Output() public apply = new EventEmitter<void>();

  private resetSubscription: Subscription;
  private applySubscription: Subscription;

  ngAfterViewInit(): void {
    this.resetSubscription = this.filtersComponent.getResetObservable().subscribe(() => this.reset.emit());
    this.applySubscription = this.filtersComponent.getApplyObservable().subscribe(() => this.apply.emit());
  }
}

